import { combineReducers } from 'redux'
import { accountsReducer as accounts } from './accounts/reducer'
import { authReducer as auth } from './auth/reducer'
import balance from './balance/balance.slice'
import { dialogReducer as dialog } from './dialog/reducer'
import { wishlistReducer as wishlist } from './wishlist/reducer'
import { ordersReducer as orders } from './orders/reducer'
import { pagesReducer as pages } from './pages/reducer'
import { privacyPolicyReducer as privacyPolicy } from './privacyPolicy/reducer'
import { profileReducer as profile } from './profile/reducer'
import { promoCodesReducer as promoCodes } from './promotions/reducer'
import { rewardsEarnPublicReducer as rewardsEarnPublic } from './rewardsEarnPublic/reducer'
import { rewardsEarnReducer as rewardsEarn } from './rewardsEarn/reducer'
import { rewardsPublicReducer as rewardsPublic } from './rewardsPublic/reducer'
import { rewardsReducer as rewards } from './rewards/reducer'
import { statementReducer as statement } from './statement/reducer'
import { searchRewardsReducer as searchRewards } from './search/reducer'
import { termsAndConditionsReducer as termsAndConditions } from './termsAndConditions/reducer'
import { toastReducer as toast } from './toast/reducer'
import { walletReducer as wallet } from './wallet/reducer'
import featureFlags from './features/features.slice'
import { deeplinkReducer as deeplink } from './deeplink'

export const reducer = combineReducers({
  accounts,
  auth,
  balance,
  dialog,
  wishlist,
  orders,
  pages,
  privacyPolicy,
  profile,
  promoCodes,
  rewards,
  rewardsEarn,
  rewardsEarnPublic,
  rewardsPublic,
  searchRewards,
  statement,
  termsAndConditions,
  toast,
  wallet,
  featureFlags,
  deeplink,
})
